<template>
    <div class="nf-top-select nf-box-bg-style">
        <el-row
            v-if="isTopRow"
            type="flex"
            class="top"
            align="middle"
            justify="space-between"
        >
            <h1 class="h1 flex-1">
                {{ topLeftText?topLeftText:this.$route.meta.title }}
            </h1>
            <!-- 标题右侧搜索 -->
            <slot
                name="top-title-right" 
            />
            <!-- 顶部右侧高级搜索按钮 -->
            <el-row
                type="flex"
                justify="end"
            >
                <el-button
                    v-if="isMoreSearchBtn"
                    type="text"
                >
                    高级搜索
                </el-button>
            </el-row>
        </el-row>
        <el-row
            type="flex"
            class="btm"
            align="middle"
            justify="space-between"
        >
            <el-col>
                <el-row type="flex">
                    <!-- 顶部默认搜索插槽 -->
                    <slot name="default-search" />
                    <!-- 更多搜索插槽 -->
                    <slot name="default-search-more" />
                </el-row>
            </el-col>
            <el-col class="search-box">
                <el-row
                    type="flex"
                    justify="end"
                >
                    <el-button
                        :size="$store.state.element.elBtnSize"
                        type="primary"
                        icon="el-icon-search"
                        @click="handleSearchBtnClick"
                        @keyup.enter="handleSearchBtnClick"
                    >
                        查询
                    </el-button>
                    <el-button
                        v-if="isResetBtn"
                        :size="$store.state.element.elBtnSize"
                        icon="el-icon-refresh-left"
                        @click="handleResetBtnClick"
                    >
                        重置
                    </el-button>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    name:'NfTopSelect',
    props:{
        // 是否显示重置按钮
        isResetBtn:{
            type:Boolean,
            default:false
        },
        // 是否显示顶部title 内一栏
        isTopRow:{
            type:Boolean,
            default:true
        },
        // 是否显示高级搜索按钮
        isMoreSearchBtn:{
            type:Boolean,
            default:false
        },
        // vuex Model 名称
        storeModelName:{
            type:String,
            required:true,
            default:''
        },
        // 点击查询按钮
        onHandleSearchBtnClick:{
            type:[Function,Boolean],
            default:false
        },
        // 点击重置按钮触发
        onHandleResetBtnClick:{
            type:[Function,Boolean],
            default:false
        },
        // 左上角文字
        topLeftText:{
            type:String,
            default:''
        }
    },
    computed:{
        // 列表参数
        params(){
            return this.$store.state[this.storeModelName].postParams;
        }
    },
    methods:{
        // 点击搜索按钮
        handleSearchBtnClick(){
            this.$store.commit(this.storeModelName+'/updatePostParams',{
                page:1
            })
            if(this.onHandleSearchBtnClick instanceof Function){
                this.onHandleSearchBtnClick()
            }else{
                this.$store.dispatch(`${this.storeModelName}/getList`);
            }
        },
        // 点击重置按钮
        handleResetBtnClick(){
            let data = {};
            let newParams = JSON.parse(JSON.stringify(this.params));
            delete newParams.page;
            delete newParams.size;
            for(let key in newParams){
                if(key!=='page' || key!=='size'){
                    if(Array.isArray(newParams[key])){
                        data[key] = []; 
                    }else{
                        data[key] = ''; 
                    }
                }
            }
            if(this.onHandleResetBtnClick){
                this.onHandleResetBtnClick();
            }else{
                this.$store.commit(`${this.storeModelName}/updatePostParams`,data)
            }
        }
    },
}
</script>
<style lang="scss" scoped>
    .nf-top-select{
        .top{
            padding: 0 20px;
            border-bottom: 1px solid #eee;
            height:34px;
            .h1{
                font-size: 14px;
                color: #333;
            }
        }
        .btm{
            padding: 0 20px;
            min-height: 60px;
        }
        .search-box{
            margin-left:20px;
            width: 168px;
        }
    }
</style>

